export enum TenantAsset {
  LogoHorizontalDark = 'logoHorizontalDark',
  LogoHorizontalLight = 'logoHorizontalLight',
  BrandmarkDark = 'brandmarkDark',
  BrandmarkLight = 'brandmarkLight',
  DecorativeImage = 'decorativeImage',
  PasswordReset = 'passwordReset',
  EmailSent = 'emailSent',
  PasswordUpdated = 'passwordUpdated',
  PhoneVerification = 'phoneVerification',
  SidebarDecoration = 'sidebarDecoration',
  SidebarLogo = 'sidebarLogo',
}
